module.exports = __webpack_public_path__ + "img/k_gon.7a3d29ee.png";